module.exports = __webpack_public_path__ + "static/img/service.134f57b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/service.jpg
// module id = y7dN
// module chunks = 1